import(/* webpackMode: "eager", webpackExports: ["MainNav"] */ "/vercel/path0/apps/web/components/main-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModeToggle"] */ "/vercel/path0/apps/web/components/mode-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/tailwind/ui/number-ticker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.1.4_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
